<template>
  <v-tooltip top :max-width="maxWidth">
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        class="mr-2"
      >mdi-{{icon}}</v-icon>
    </template>
    <div v-html="text"></div>
  </v-tooltip>
</template>
<script>
export default {
  name: 'InfoTooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'information',
    },
    maxWidth: {
      type: [String, Number]
    }
  }
}
</script>
